import React from 'react';

import { Link, Modal } from '@iwoca/orion';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getValues } from 'redux-form';

import messages from './CountryErrorModal.messages';
import styles from './CountryErrorModal.module.css';
import { toggleCountryModal } from '../../actions';
import { countryOptions } from '../../components/Address/constants';

const mapStateToProps = ({ ui, form }) => ({
    ui,
    formValues: getValues(form.sign_up)
});

const mapDispatchToProps = (dispatch) => ({
    toggleCountryModal: () => dispatch(toggleCountryModal())
});

class CountryErrorModal extends React.Component {
    renderManualAddressCountryModalEmail() {
        const personalInformation = _.get(
            this.props,
            'formValues.personalInformation'
        );

        if (!!personalInformation) {
            const countryCode =
                personalInformation.people[0].addresses[0].country;

            if (countryCode !== 'other') {
                const countryDomain = countryCode;
                return (
                    <Link
                        className={styles.externalLink}
                        href={`https://www.iwoca.${countryDomain}`}>
                        <FormattedMessage
                            {...messages.switchCountryWebsite}
                            values={{ countryDomain }}
                        />
                    </Link>
                );
            }
        }
    }

    renderManualAddressCountryModalTitle() {
        const personalInformation = _.get(
            this.props,
            'formValues.personalInformation'
        );

        if (!!personalInformation) {
            const countryCode =
                personalInformation.people[0].addresses[0].country;

            const wrongSiteTitle = (
                <FormattedMessage {...messages.wrongSiteTitle} />
            );
            const notInYourCountryTitle = (
                <FormattedMessage {...messages.notInYourCountryTitle} />
            );

            return countryCode !== 'other'
                ? wrongSiteTitle
                : notInYourCountryTitle;
        }
    }

    renderManualAddressCountryModalSubText() {
        const personalInformation = _.get(
            this.props,
            'formValues.personalInformation'
        );

        if (!!personalInformation) {
            const countryCode =
                personalInformation.people[0].addresses[0].country;
            const country = _.find(countryOptions, (country) => {
                return country.value === countryCode;
            });
            const countryLabel = country ? country.label : '';

            const wrongCountryMessage = (
                <FormattedMessage
                    {...messages.differentCountryMessage}
                    values={{ countryLabel }}
                />
            );
            const notInCountryMessage = (
                <FormattedMessage {...messages.wrongCountryMessage} />
            );

            return countryLabel !== 'Other'
                ? wrongCountryMessage
                : notInCountryMessage;
        }
    }

    handleAddressCountryModalOpening() {
        return this.props.ui.countryModalOpen;
    }

    handleAddressCountryModalClosing() {
        this.props.toggleCountryModal();
    }

    render() {
        return (
            <Modal
                isOpen={this.handleAddressCountryModalOpening()}
                onClose={this.handleAddressCountryModalClosing.bind(this)}
                title={this.renderManualAddressCountryModalTitle()}
                closeIcon
                headerBar>
                {this.renderManualAddressCountryModalSubText()}{' '}
                {this.renderManualAddressCountryModalEmail()}
            </Modal>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CountryErrorModal);
